import { useEffect, useState } from 'react';
import { getBusinessSettings } from '../../api/getBusinessSettings';
import { SiTiktok } from 'react-icons/si';
import { FaLinkedin, FaTelegramPlane } from 'react-icons/fa';

const HeaderTopbar = ({ mobile }) => {
  const [settings, setSettings] = useState(null);
  const [hoveredIcon, setHoveredIcon] = useState(null);

  useEffect(() => {
    getBusinessSettings().then(setSettings);
  }, []);

  if (!settings) return null;

  const iconStyle = (iconName) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '16px',
    width: '42px',
    height: '42px',
    borderRadius: '50%',
    color: hoveredIcon === iconName ? '#fff' : (mobile ? '#333' : '#e4e4e4'),
    background: hoveredIcon === iconName
      ? 'linear-gradient(135deg, #001f4d, #004aad, #66b2ff)'
      : (mobile ? '#f1f4f9' : 'transparent'),
    border: '1px solid rgba(0,0,0,0.1)',
    transition: 'all 0.3s ease',
  });

  return (
    <div
      className={`topbar ${mobile ? 'mobile-topbar-box' : 'd-none d-lg-block'}`}
      style={{
        background: mobile ? 'transparent' : 'linear-gradient(135deg, #001f4d, #004aad, #66b2ff)',
        padding: mobile ? '15px' : '8px 20px',
        fontSize: '15px',
        color: mobile ? '#333' : '#e5e3e3',
        borderRadius: mobile ? '12px' : '0',
        boxShadow: mobile ? '0 4px 10px rgba(0,0,0,0.08)' : 'none',
        marginTop: mobile ? '20px' : '0',
      }}
    >
      <div className="container-fluid">
        <div
          className="row align-items-center"
          style={{
            flexDirection: mobile ? 'column' : 'row',
            alignItems: mobile ? 'flex-start' : 'center',
            gap: mobile ? '10px' : '0',
          }}
        >
          {/* CONTACTS SECTION */}
          <div
            className="col"
            style={{
              width: '100%',
            }}
          >
            <div className="contact-intro">
              <ul
                style={{
                  listStyle: 'none',
                  margin: 0,
                  padding: 0,
                  display: 'flex',
                  flexDirection: mobile ? 'column' : 'row',
                  gap: mobile ? '8px' : '15px',
                }}
              >
                <li style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <i className="fi flaticon-phone-call-1"></i>
                  <span>{settings.phone1}</span>
                </li>
                <li style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <i className="fi flaticon-email-1"></i>
                  <span>{settings.email}</span>
                </li>
                <li style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <i className="fi flaticon-location"></i>
                  <span>{settings.address}</span>
                </li>
              </ul>
            </div>
          </div>

          {/* SOCIAL ICONS */}
          <div
            className="col"
            style={{
              width: '100%',
              marginTop: mobile ? '15px' : '0',
            }}
          >
            <ul
              className="social"
              style={{
                display: 'flex',
                flexWrap: mobile ? 'wrap' : 'nowrap',
                justifyContent: mobile ? 'center' : 'flex-end',
                gap: '10px',
                listStyle: 'none',
                margin: 0,
                padding: 0,
              }}
            >
              {settings.facebookLink && (
                <li>
                  <a
                    href={settings.facebookLink}
                    onMouseEnter={() => setHoveredIcon('facebook')}
                    onMouseLeave={() => setHoveredIcon(null)}
                    style={iconStyle('facebook')}
                  >
                    <i className="ti-facebook"></i>
                  </a>
                </li>
              )}
              {settings.twitterLink && (
                <li>
                  <a
                    href={settings.twitterLink}
                    onMouseEnter={() => setHoveredIcon('twitter')}
                    onMouseLeave={() => setHoveredIcon(null)}
                    style={iconStyle('twitter')}
                  >
                    <i className="ti-twitter-alt"></i>
                  </a>
                </li>
              )}
              {settings.instagramLink && (
                <li>
                  <a
                    href={settings.instagramLink}
                    onMouseEnter={() => setHoveredIcon('instagram')}
                    onMouseLeave={() => setHoveredIcon(null)}
                    style={iconStyle('instagram')}
                  >
                    <i className="ti-instagram"></i>
                  </a>
                </li>
              )}
              {settings.tiktokLink && (
                <li>
                  <a
                    href={settings.tiktokLink}
                    onMouseEnter={() => setHoveredIcon('tiktok')}
                    onMouseLeave={() => setHoveredIcon(null)}
                    style={iconStyle('tiktok')}
                  >
                    <SiTiktok />
                  </a>
                </li>
              )}
              {settings.telegramLink && (
                <li>
                  <a
                    href={settings.telegramLink}
                    onMouseEnter={() => setHoveredIcon('telegram')}
                    onMouseLeave={() => setHoveredIcon(null)}
                    style={iconStyle('telegram')}
                  >
                    <FaTelegramPlane />
                  </a>
                </li>
              )}
              {settings.linkedInLink && (
                <li>
                  <a
                    href={settings.linkedInLink}
                    onMouseEnter={() => setHoveredIcon('linkedin')}
                    onMouseLeave={() => setHoveredIcon(null)}
                    style={iconStyle('linkedin')}
                  >
                    <FaLinkedin />
                  </a>
                </li>
              )}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeaderTopbar;
